import { createContext, useEffect, useState } from 'react'
import clienteAxios from '../config/clienteAxios';

const FaqsContext = createContext()

const FaqsProvider = ({ children }) => {
  const [faqs, setFaqs] = useState([]);

  useEffect(() => {
    const getFaqs = async () => {
      try {
        const { data } = await clienteAxios.get("/faq");

        setFaqs(data.allFaqs);
      } catch (error) {
        // console.log('error:', error);
      }
    }

    getFaqs();
}, []);

const getFaqsByParams = async (params) => {
  try {
    const { data } = await clienteAxios.post("/faq/getbyparams", params);
    
    return data.faqsByParam
  } catch (error) {
    // console.log(error)
  }
}

return (
  <FaqsContext.Provider 
  value={{ 
    faqs,
    getFaqsByParams,
    }}
    >
      {children}
  </FaqsContext.Provider>
)
}

export { FaqsProvider }

export default FaqsContext;